import { jwtDecode } from "jwt-decode";
import * as types from 'constants/actionTypes';
import AL from 'constants/authorizationLevel';
import getAxiosInstance from 'utils/AxiosApi';
import initialState from './initialState';
import config from "config/env";

const AxiosInstance = getAxiosInstance();

export default function commonReducer(state = initialState.common, action) {
  switch (action.type) {
    case "INIT_ACCOUNTPAGE":
      return {
        ...state, user: { userName: "iman", authorizationLevel: AL.ADMIN }
      };

    case types.UNAUTHORIZED_USER: {
      return {
        ...state,
        "unauthorizedUser": true
      };
    }

    //Adding Axios
    case types.INIT_LOGIN: {
      let token = JSON.parse(localStorage.getItem("TECHPOS"));
      let authenticated = false;
      let user = {};

      if (token) {
        try {
          let decoded = jwtDecode(token.token);
          if (decoded.exp * 1000 <= new Date().getTime()) {
            AxiosInstance.flushToken();
            return {
              ...state,
              "isUserAuthenticated": authenticated,
              "authenticatedUser": authenticated ? user : null,
              "unauthorizedUser": false,
              "loginSuccess": null,
              "loginError": null,
              "loginErrorTimeStamp": null,
              "forgetPasswordSuccess": null,
              "forgetPasswordSaveTimeStamp": null
            };
          }
          //Sets Token
          AxiosInstance.setToken(token.token);
          user.firstName = decoded.FirstName;
          user.lastName = decoded.LastName;
          user.userName = decoded.UserName;
          user.roles = Array.isArray(decoded.roles) ? decoded.roles : [decoded.roles];
          user.storeId = Array.isArray(decoded.StoreId) ? decoded.StoreId : [decoded.StoreId];
          user.claims = decoded['Permission.Claims'] && (Array.isArray(decoded['Permission.Claims']) ? decoded['Permission.Claims'] : [decoded['Permission.Claims']]);
          authenticated = true;
        } catch (error) {
          console.log("error token: " + error);
          AxiosInstance.flushToken();
          authenticated = false;
        }
      }
      return {
        ...state,
        "isUserAuthenticated": authenticated,
        "authenticatedUser": authenticated ? user : null,
        "unauthorizedUser": false,
        "loginSuccess": null,
        "loginError": null,
        "loginErrorTimeStamp": null,
        "forgetPasswordSuccess": null,
        "forgetPasswordSaveTimeStamp": null
      };
    }

    case types.OPEN_CHANGEPASSWORD_DIALOG: {
      return {
        ...state,
        isChangePasswordModalOpen: true
      };
    }

    case types.CLOSE_CHANGEPASSWORD_DIALOG: {
      return {
        ...state,
        isChangePasswordModalOpen: false
      };
    }

    //Adding Axios
    case types.LOGIN_REQUEST_SUCCESS: {
      localStorage.setItem("TECHPOS", JSON.stringify(action.data));
      let user = {};
      if (action && action.data) {
        try {
          let decoded = jwtDecode(action.data.token);
          if (decoded.exp * 1000 <= new Date().getTime()) {
            //Flush token
            AxiosInstance.flushToken();
            throw "Expired jwt";
          }
          //Sets Token
          AxiosInstance.setToken(action.data.token);

          user.firstName = decoded.FirstName;
          user.lastName = decoded.LastName;
          user.userName = decoded.UserName;
          user.roles = Array.isArray(decoded.roles) ? decoded.roles : [decoded.roles];
          user.storeId = Array.isArray(decoded.StoreId) ? decoded.StoreId : [decoded.StoreId];
          user.claims = decoded['Permission.Claims'] && (Array.isArray(decoded['Permission.Claims']) ? decoded['Permission.Claims'] : [decoded['Permission.Claims']]);
        } catch (error) {
          AxiosInstance.flushToken();
          console.log("error token: " + error);
        }
      }
      return {
        ...state,
        "loginSuccess": true,
        "isUserAuthenticated": true,
        "loginError": null,
        "loginErrorTimeStamp": null,
        "unauthorizedUser": false,
        "authenticatedUser": user ? user : null
      };
    }

    case types.AUTH_PIN_PASSWORD_SUCCESS: {
      localStorage.setItem("TECHPOS", JSON.stringify(action.data));
      let user = {};
      if (action && action.data) {
        try {
          let decoded = jwtDecode(action.data.token);
          if (decoded.exp * 1000 <= new Date().getTime()) {
            //Flush token
            AxiosInstance.flushToken();
            throw "Expired jwt";
          }
          //Sets Token
          AxiosInstance.setToken(action.data.token);

          user.firstName = decoded.FirstName;
          user.lastName = decoded.LastName;
          user.userName = decoded.UserName;
          user.roles = Array.isArray(decoded.roles) ? decoded.roles : [decoded.roles];
          user.storeId = Array.isArray(decoded.StoreId) ? decoded.StoreId : [decoded.StoreId];
          user.claims = decoded['Permission.Claims'] && (Array.isArray(decoded['Permission.Claims']) ? decoded['Permission.Claims'] : [decoded['Permission.Claims']]);
        } catch (error) {
          AxiosInstance.flushToken();
          console.log("error token: " + error);
        }
      }
      return {
        ...state,
        "authenticatedUser": user ? user : null
      };
    }

    case types.LOGIN_REQUEST_FAILED: {
      localStorage.removeItem('TECHPOS_SELECTED_BRANCH');
      localStorage.removeItem('TECHPOS');
      return {
        ...state,
        "loginSuccess": false,
        "loginError": action.data,
        "isUserAuthenticated": false,
        "loginErrorTimeStamp": new Date().toLocaleTimeString(),
        "unauthorizedUser": false,
        "userBranches": undefined,
        "branchId": null
      };
    }
    case types.LOGOUT_REQUEST: {
      localStorage.removeItem('TECHPOS_SELECTED_BRANCH');
      localStorage.removeItem('TECHPOS');
      localStorage.setItem('TECHPOS_FolderName', JSON.stringify(""));
      localStorage.setItem('IsLoggedOut', "true");
      AxiosInstance.flushToken();

      const pinUser = {
        authenticated: false,
        employee: {
          id: 0,
          name: ''
        }
      };

      sessionStorage.setItem('pinUser', JSON.stringify(pinUser));
      return {
        ...state,
        "isUserAuthenticated": false,
        "authenticatedUser": null,
        "unauthorizedUser": false,
        "userBranches": undefined,
        "branchId": null,
        applicationSettings: initialState.common.applicationSettings,
        store: initialState.common.store
      };
    }
    case types.SNACKBAR_SHOW_MESSAGE:
      return {
        ...state, snackbar: { open: true, message: action.message }
      };
    case types.SNACKBAR_HIDE_MESSAGE:
      return {
        ...state, snackbar: { open: false, message: '' }
      };
    case types.DIALOG_ALERT_OPEN:
      return {
        ...state, [(action.compName ? action.compName : "dialog") + "Alert"]: { open: true, message: action.message, onClose: action.onClose }
      };
    case types.DIALOG_ALERT_CLOSE:
      return {
        ...state, [(action.compName ? action.compName : "dialog") + "Alert"]: { open: false, message: '', onClose: null }
      };
    case types.SHOW_LOADING: {
      return {
        ...state,
        loading: true
      }
    }
    case types.HIDE_LOADING: {
      return {
        ...state,
        loading: false,
        loadingMsg: null
      }
    }
    case types.SHOW_DOWNLOADING: {
      return {
        ...state,
        loading: true,
        loadingMsg: "Downloading"
      }
    }
    case "LOADING": {
      let actualValue = isNaN(state.ajaxCallsInProgress) ? 0 : state.ajaxCallsInProgress;
      return {
        ...state, ajaxCallsInProgress: (actualValue + action.val) == -1 ? 0 : actualValue + action.val
      };
    }

    case "HIDDEN-LOADING": {
      let actualValue = state.ajaxCallsInProgress == 1 ? 0 : state.ajaxCallsInProgress;
      return {
        ...state, ajaxCallsInProgress: actualValue
      };
    }
    //LOADING DASHBOARD
    case "DB-ORDERS-LOADING": {
      let actualValue = isNaN(state.dbOrdersCall) ? 0 : state.dbOrdersCall;
      return {
        ...state, dbOrdersCall: actualValue + action.val
      };
    }
    case "DB-TOPPRODUCTS-LOADING": {
      let actualValue = isNaN(state.dbTopProductsCall) ? 0 : state.dbTopProductsCall;
      return {
        ...state, dbTopProductsCall: actualValue + action.val
      };
    }
    case "DB-PO-LOADING": {
      let actualValue = isNaN(state.dbPoCall) ? 0 : state.dbPoCall;
      return {
        ...state, dbPoCall: actualValue + action.val
      };
    }
    case "DB-TOPSELLERS-LOADING": {
      let actualValue = isNaN(state.dbTopSellersCall) ? 0 : state.dbTopSellersCall;
      return {
        ...state, dbTopSellersCall: actualValue + action.val
      };
    }
    case "DB-CAMPAINGS-LOADING": {
      let actualValue = isNaN(state.dbCampaingsCall) ? 0 : state.dbCampaingsCall;
      return {
        ...state, dbCampaingsCall: actualValue + action.val
      };
    }
    case "DB-CASHFLOW-LOADING": {
      let actualValue = isNaN(state.dbCashFlowCall) ? 0 : state.dbCashFlowCall;
      return {
        ...state, dbCashFlowCall: actualValue + action.val
      };
    }
    case "DB-TOTALSALES-LOADING": {
      let actualValue = isNaN(state.dbTotalSales) ? 0 : state.dbTotalSales;
      return {
        ...state, dbTotalSales: actualValue + action.val
      };
    }
    case "DB-TOPMEMBERS-LOADING": {
      let actualValue = isNaN(state.dbTopMembers) ? 0 : state.dbTopMembers;
      return {
        ...state, dbTopMembers: actualValue + action.val
      };
    }
    case "DB-INVENTORY-LOADING": {
      let actualValue = isNaN(state.dbInventory) ? 0 : state.dbInventory;
      return {
        ...state, dbInventory: actualValue + action.val
      };
    }
    case "DB-CLOCKIN-LOADING": {
      let actualValue = isNaN(state.dbClockIn) ? 0 : state.dbClockIn;
      return {
        ...state, dbClockIn: actualValue + action.val
      };
    }

    case "DB-INVENTORYSNAPSHOT-LOADING": {
      let actualValue = isNaN(state.dbInventorySnapshot) ? 0 : state.dbInventorySnapshot;
      return {
        ...state, dbInventorySnapshot: actualValue + action.val
      };
    }

    case "AUDIT-LOADING": {
      let actualValue = isNaN(state.auditUpdating) ? 0 : state.auditUpdating;
      return {
        ...state, auditUpdating: actualValue + action.val
      };
    }

    case types.STORES_GOT_ALL: {
      return {
        ...state,
        storesList: [...action.stores]
      };
    }

    case types.SELECT_STORE: {
      return {
        ...state,
        store: {
          ...state.store,
          apiUrl: config.baseUrl(),
          posAPIUrl: config.posAPIUrl()
        }
      }
    }

    case types.SET_BRANCH_CONTEXT: {
      localStorage.setItem('TECHPOS_SELECTED_BRANCH', action.branchId);

      return {
        ...state,
        branchId: action.branchId
      };
    }

    case types.GET_USER_BRANCHES_SUCCESS: {
      return {
        ...state,
        userBranches: action.data.branches
      };
    }

    case types.GET_USER_BRANCHES_ERROR: {
      return {
        ...state,
        userBranches: null
      };
    }

    case types.CHANGE_USER_BRANCH: {
      localStorage.removeItem('TECHPOS_SELECTED_BRANCH');
      return {
        ...state,
        branchId: null,
        applicationSettings: initialState.common.applicationSettings
      };
    }

    // APPLICATION SETTING
    case types.APPLICATION_SETTING_GOT:
    case types.APPLICATION_SETTING_SAVED:
    case types.UPDATE_TWILIO_INFO_SUCCESS: {
      return {
        ...state,
        applicationSettings: {
          ...state.applicationSettings,
          ageValidation: action.data.ageValidation,
          cashDropAmount: action.data.cashDropAmount,
          cashDropAmountToKeep: action.data.cashDropAmountToKeep,
          cashInAmountByDefault: action.data.cashInAmountByDefault,
          deviceKeyName: action.data.deviceKeyName,
          doNotShowUnitProductQuantityOver: action.data.doNotShowUnitProductQuantityOver,
          doNotShowWeightProductQuantityOver: action.data.doNotShowWeightProductQuantityOver,
          enablePinPasswordOnPOS: action.data.enablePinPassword,
          memberDiscountPercentage: action.data.memberDiscountPercentage,
          preRollCategoryId: action.data.preRollCategoryId,
          suggestedCashDropAmount: action.data.suggestedCashDropAmount,
          tokenName: action.data.tokenName,
          toleranceCashOutAmount: action.data.toleranceCashOutAmount,
          isMedical: action.data.applicationType == 1 ? true : false,
          isVape: action.data.applicationType == 3 ? true : false,
          hasWebMenu: action.data.hasWebMenu,
          posFraudProtection: action.data.posFraudProtection,
          isLegal: action.data.isLegal,
          storeName: action.data.name,
          storePhone: action.data.phone,
          storeSite: action.data.webSite,
          storeStreet: action.data.address,
          storeCity: action.data.city,
          storeProvinceState: action.data.provinceState,
          storeCountry: action.data.country,
          storePostalCode: action.data.postalCode,
          gstNumber: action.data.gstNumber,
          hideRewardsReceipt: action.data.hideRewardsReceipt,
          hideMedicalLabelReceipt: action.data.hideMedicalLabelReceipt,
          memberLabelReceipt: action.data.memberLabelReceipt,
          monerisEnabled: action.data.monerisEnabled,
          monerisStoreId: action.data.monerisStoreId,
          monerisPostUrl: action.data.monerisPostUrl,
          shippingCostEnabled: action.data.shippingCostEnabled,
          digitalSignageEnabled: action.data.digitalSignageEnabled,
          picEnabled: action.data.picEnabled,
          wordpressEnabled: action.data.wordpressEnabled,
          numberOfCopies: action.data.numberOfCopies,
          pickUpEnabled: action.data.pickUpEnabled,
          memberEnabled: action.data.memberEnabled,
          cancelOrderNeedApproval: action.data.cancelOrderNeedApproval,
          discountNeedApproval: action.data.discountNeedApproval,
          padVersion: action.data.padVersion,
          isShopNameDisplayed: action.data.isShopNameDisplayed,
          idPopupEnabled: action.data.idPopupEnabled,
          cashInEnabled: action.data.cashInEnabled,
          rewardPointsDivider: action.data.rewardPointsDivider,
          rewardPointsPerDollarSpent: action.data.rewardPointsPerDollarSpent,
          lotNumberEnabled: action.data.lotNumberEnabled,
          receivePOToStore: action.data.receivePOToStore,
          buddiEnabled: action.data.buddiEnabled,
          leaflyEnabled: action.data.leaflyEnabled,
          voidItemShowOnReceipt: action.data.voidItemShowOnReceipt,
          hvcMonthlySpent: action.data.hvcMonthlySpent,
          hvcRewardPointsDivider: action.data.hvcRewardPointsDivider,
          showImageInPOSPage: action.data.showImageInPOSPage,
          branchTransferManuallyReceive: action.data.branchTransferManuallyReceive,
          fianlSaleTextShowOnReceipt: action.data.fianlSaleTextShowOnReceipt,
          fulfillmentEnabled: action.data.fulfillmentEnabled,
          monerisCustomerCopyAutoPrinted: action.data.monerisCustomerCopyAutoPrinted,
          printingServerInterval: action.data.printingServerInterval,
          fulfillmentPayFirst: action.data.fulfillmentPayFirst,
          onlyCashPaymentOpenDrawer: action.data.onlyCashPaymentOpenDrawer,
          monerisMerchantCopyAutoPrinted: action.data.monerisMerchantCopyAutoPrinted,
          payFirmaEnabled: action.data.payFirmaEnabled,
          payFirmaUrl: action.data.payFirmaUrl,
          payFirmaToken: action.data.payFirmaToken,
          getOpenOnlineOrdersInterval: action.data.getOpenOnlineOrdersInterval,
          getWordpressOrdersInterval: action.data.getWordpressOrdersInterval,
          monerisGiftCardEnabled: action.data.monerisGiftCardEnabled,
          showRemoveFNTaxBtn: action.data.showRemoveFNTaxBtn,
          showVapeProductSaleDialog: action.data.showVapeProductSaleDialog,
          storeManagerCanAccessDashboard: action.data.storeManagerCanAccessDashboard,
          showEmployeeNameOnReceipt: action.data.showEmployeeNameOnReceipt,
          posReceiptBottomText: action.data.posReceiptBottomText,
          posShowProductCount: action.data.posShowProductCount,
          showOpenOnlineOrders: action.data.showOpenOnlineOrders,
          showOpenOrders: action.data.showOpenOrders,
          weedmapsEnable: action.data.weedmapsEnable,
          posShowCategories: action.data.posShowCategories,
          crossProvincesMerchant: action.data.crossProvincesMerchant,
          paystoneGiftCardEnabled: action.data.paystoneGiftCardEnabled,
          visitCountsForDiscount: action.data.visitCountsForDiscount,
          visitCountDiscount: action.data.visitCountDiscount,
          receivePurchaseOrderWhenCreate: action.data.receivePurchaseOrderWhenCreate,
          trackProductChange: action.data.trackProductChange,
          springbigApiKey: action.data.springbigApiKey,
          logoUrl: action.data.logoUrl,
          alpineIQApiKey: action.data.alpineiqAPIKey,
          hideRewards: action.data.hideRewards,
          alpineIQwalletCode: action.data.alpineIQwalletCode,
          showOriginalNonMemberPrice: action.data.showOriginalNonMemberPrice,
          pOSProductsScroll: action.data.posProductsScroll,
          paymentPastDue: action.data.paymentPastDue,
          alpineIQCheckIn: action.data.alpineIQCheckIn,
          noSalesAllowedAfterStoreHours: action.data.noSalesAllowedAfterStoreHours,
          storeOpenHour: action.data.storeOpenHour,
          storeCloseHour: action.data.storeCloseHour,
          birthDateNotMandatory: action.data.birthDateNotMandatory,
          salesPersonAccessOnlineOrders: action.data.salesPersonAccessOnlineOrders,
          salesPersonAccessPOSDiscounts: action.data.salesPersonAccessPOSDiscounts,
          birchmountGiftCardEnabled: action.data.birchmountGiftCardEnabled,
          ownTwilioEnabled: action.data.ownTwilioEnabled,
          ownTwilioSID: action.data.ownTwilioSID,
          ownTwilioAuthToken: action.data.ownTwilioAuthToken,
          ownTwilioFromNumber: action.data.ownTwilioFromNumber,
          springBigRewardsOff: action.data.springBigRewardsOff,
          dutchieIsEnabled: action.data.dutchieApiKey ? true : false,
          inStoreTipEnabled: action.data.inStoreTipEnabled,
          receiptShowGSTNumber: action.data.receiptShowGSTNumber,
          receiptShowTerminal: action.data.receiptShowTerminal,
          receiptShowEmployeeFirstName: action.data.receiptShowEmployeeFirstName,
          receiptShowEmployeeLastName: action.data.receiptShowEmployeeLastName,
          receiptShowOrderNumber: action.data.receiptShowOrderNumber,
          receiptShowMemberSavings: action.data.receiptShowMemberSavings,
          receiptShowProductCount: action.data.receiptShowProductCount,
          receiptShowMemberName: action.data.receiptShowMemberName,
          receiptShowMemberPoints: action.data.receiptShowMemberPoints,
          receiptShowVisitCount: action.data.receiptShowVisitCount,
          receiptShowCreatedDate: action.data.receiptShowCreatedDate,
          internalMessage: action.data.internalMessage,
          bannerImageURL: action.data.bannerImageURL,
          ocsHashKey: action.data.ocsHashKey,
          posMemberCheckInEnabled: action.data.posMemberCheckInEnabled,
          salesPersonDiscountThreshold: action.data.salesPersonDiscountThreshold,
          stackDiscountsEnabled: action.data.stackDiscountsEnabled,
          genericGiftCardEnabled: action.data.genericGiftCardEnabled,
          generalAccessorySaleEnabled: action.data.generalAccessorySaleEnabled,
          refundNeedManagerApproval: action.data.refundNeedManagerApproval,
          hideSearchBar: action.data.hideSearchBar,
          paystoneInStoreEnabled: action.data.paystoneInStoreEnabled,
          stickyCardsEnabled: action.data.stickyCardsEnabled,
          taxExemptAllEnabled: action.data.taxExemptAllEnabled,
          storeCreditExpirationDays: action.data.storeCreditExpirationDays,
          cannaCollectiveEnabled: action.data.cannaCollectiveEnabled,
          irccEnabled: action.data.irccEnabled,
          quickBooksEnabled: action.data.quickBooksEnable,
          fulfillmentScanManagerApproval: action.data.fulfillmentScanManagerApproval,
          fulfillmentMustScanAllForComplete: action.data.fulfillmentMustScanAllForComplete,
          pinPadPaymentManagerApproval: action.data.pinPadPaymentManagerApproval,
          showPOSBulkImport: action.data.showPOSBulkImport,
          showAddMemberAfterSale: action.data.showAddMemberAfterSale,
          logoutPinAfterSeconds: action.data.logoutPinAfterSeconds,
          offlineProductScan: action.data.offlineProductScan,
          cachingProducts: action.data.cachingProducts,
          priceMatchPlusPercentage: action.data.priceMatchPlusPercentage,
          isHighTide: action.data.isHighTide,
          isInspired: action.data.isInspired,
          globalInStorePaymentEnabled: action.data.globalInStorePaymentEnabled,
          adyenInStorePaymentEnabled: action.data.adyenInStorePaymentEnabled,
          adyenInStorePaymentAPIKey: action.data.adyenInStorePaymentAPIKey,
          httpPrintingEnabled: action.data.httpPrintingEnabled
        },
        store: {
          ...state.store,
          name: action.data.name,
          phone: action.data.phone,
          site: action.data.webSite,
          street: action.data.address,
          city: action.data.city,
          provinceState: action.data.provinceState,
          country: action.data.country,
          postalCode: action.data.postalCode,
          GSTNumber: action.data.gstNumber,
          hideRewardsReceipt: action.data.hideRewardsReceipt,
          hideMedicalLabelReceipt: action.data.hideMedicalLabelReceipt,
          memberLabelReceipt: action.data.memberLabelReceipt,
          monerisEnabled: action.data.monerisEnabled,
          monerisStoreId: action.data.monerisStoreId,
          monerisPostUrl: action.data.monerisPostUrl,
          shippingCostEnabled: action.data.shippingCostEnabled,
          digitalSignageEnabled: action.data.digitalSignageEnabled,
          picEnabled: action.data.picEnabled,
          version: action.data.version,
          payFirmaEnabled: action.data.payFirmaEnabled,
          payFirmaUrl: action.data.payFirmaUrl,
          payFirmaToken: action.data.payFirmaToken,
          monerisGiftCardEnabled: action.data.monerisGiftCardEnabled,
          ampAuthCode: action.data.ampAuthCode,
          ampBaseUrl: action.data.ampBaseUrl,
          crsaNumber: action.data.crsaNumber,
          primaryContactFullName: action.data.primaryContactFullName,
          primaryContactEmail: action.data.primaryContactEmail,
          secondaryContactFullName: action.data.secondaryContactFullName,
          secondaryContactEmail: action.data.secondaryContactEmail,
          managementEmployeeCount: action.data.managementEmployeeCount,
          administrativeEmployeeCount: action.data.administrativeEmployeeCount,
          salesEmployeeCount: action.data.salesEmployeeCount,
          productionEmployeeCount: action.data.productionEmployeeCount,
          otherEmployeeCount: action.data.otherEmployeeCount,
          dutchieIsEnabled: action.data.dutchieapikey ? true : false,
          paymentreeInStoreEnabled: action.data.paymentreeInStoreEnabled,
          picPoyntInStoreEnabled: action.data.picPoyntInStoreEnabled,
          paystoneInStoreEnabled: action.data.paystoneInStoreEnabled,
          globalInStorePaymentEnabled: action.data.globalInStorePaymentEnabled,
          adyenInStorePaymentEnabled: action.data.adyenInStorePaymentEnabled,
          aydenInStorePaymentAPIKey: action.data.adyenInStorePaymentAPIKey,
          httpPrintingEnabled: action.data.httpPrintingEnabled
        }
      };
    }

    case types.HANDLE_CHECKIN_DIALOG: {
      return {
        ...state,
        checkInDialog: !state.checkInDialog
      }
    }

    default:
      return state;
  }
}
